<div class="d-flex justify-content-between dialog-title">
  <div>
    <p class="mb-0 mt-1 dialog-title">Delete Item</p>
  </div>
  <div>
    <button [mat-dialog-close]="true" mat-icon-button>
      <mat-icon class="dialog-icon">close</mat-icon>
    </button>
  </div>
</div>
<hr>
<form [formGroup]="deleteOrderForm" (ngSubmit)="onDelete()">
  <div mat-dialog-content>
    <div class="d-flex m-auto text-center justify-content-center">
      <p class="mb-0 fs-6">Are you sure you want to delete <br>
        <span class="fw-bold">"{{ data.orderNumber }}"</span> ? <br>
        <span class="fw-bold">This Action Cannot be undone!</span>
      </p>
    </div>

    <nz-form-item>
      <div class="w-100">
        <nz-form-label nzRequired>Delete Reason</nz-form-label>
        <nz-form-control nzErrorTip="Delete reason is required!">
          <input formControlName="deleteReason" nz-input placeholder="Enter delete reason">
        </nz-form-control>
      </div>
    </nz-form-item>
  </div>
  <div class="mt-3 d-flex justify-content-end mb-4 me-4">
    <button class="w-25 btn-radius me-2" [mat-dialog-close]="true" nzType="primary" nzGhost nz-button>
      Cancel
    </button>
    <button nz-button nzType="primary" class="w-25 btn-radius" nzDanger>
      Delete
    </button>
  </div>
</form>
